import { useIsAdmin } from "domains/auth";
import React from "react";
import { useHasAnySupportOpsCapability } from "./capabilities";

const SuperAdminPanelBody = React.lazy(() =>
  import("./Panel").then(({ SuperAdminPanelBody }) => ({ default: SuperAdminPanelBody })),
);

// EXPERIMENTAL SuperAdmin tools panel (right-side Sheet). Shown to admins holding a granted
// support-ops tool; body code lazy-loads only once the gate opens.
export function SuperAdminPanel() {
  const isAdmin = useIsAdmin();
  const hasSupportOpsTool = useHasAnySupportOpsCapability();

  if (!isAdmin || !hasSupportOpsTool) return null;

  return (
    <React.Suspense fallback={null}>
      <SuperAdminPanelBody />
    </React.Suspense>
  );
}
